<template>
  <div class="image-grid">
    <div
      class="row"
      v-if="data.length == 4"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-6 pl-0" style="padding-right: 9px">
        <div class="row">
          <div class="col-12 o-hidden">
            <div
              @click="showImage(0)"
              :style="'background-image: url(' + data[0].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-12 o-hidden">
            <div
              @click="showImage(1)"
              :style="'background-image: url(' + data[1].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
      <div class="col-6 pr-0" style="padding-left: 9px">
        <div class="row">
          <div class="col-12 o-hidden">
            <div
              @click="showImage(2)"
              :style="'background-image: url(' + data[2].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-12 o-hidden">
            <div
              @click="showImage(3)"
              :style="'background-image: url(' + data[3].image_thumb +  '); background-size: cover; height: calc(50vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="data.length == 1"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-12">
        <div class="row">
          <div class="col-12 o-hidden p-0">
            <div
              @click="showImage(0)"
              :style="'background-image: url(' + data[0].image_thumb +  '); background-size: cover; height: calc(100vw'"
              class="w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="data.length == 2"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-12 pl-0">
        <div class="row">
          <div class="col-6 o-hidden pr-0" style="padding-right: 9px">
            <div
              @click="showImage(0)"
              :style="'background-image: url(' + data[0].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-6 o-hidden pr-0" style="padding-right: 9px">
            <div
              @click="showImage(1)"
              :style="'background-image: url(' + data[1].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="data.length == 3"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-4 pl-0">
        <div class="row">
          <div class="col-12 o-hidden">
            <div
              @click="showImage(0)"
              :style="'background-image: url(' + data[0].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-12 o-hidden">
            <div
              @click="showImage(1)"
              :style="'background-image: url(' + data[1].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="row">
          <div
            @click="showImage(2)"
            :style="'background-image: url(' + data[2].image_thumb +  '); background-size: cover; height: calc(66vw)'"
            class="w-100"
          />
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="data.length >=5"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-4 pl-0" style="padding-right: 9px">
        <div class="row">
          <div class="col-12 o-hidden">
            <div
              @click="showImage(0)"
              :style="'background-image: url(' + data[0].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-12 o-hidden">
            <div
              @click="showImage(1)"
              :style="'background-image: url(' + data[1].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
      <div class="col-8 pr-0" style="padding-left: 9px">
        <div class="row">
          <div class="col-12 o-hidden">
            <div
              @click="showImage(2)"
              :style="'background-image: url(' + data[2].image_thumb +  '); background-size: cover; height: calc(66vw - 9px)'"
              class="w-100"
            />
          </div>
          <div class="col-12 o-hidden">
            <div class="row">
              <div class="col-6" style="padding-right: 9px">
                <div
                  @click="showImage(3)"
                  :style="'background-image: url(' + data[3].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'"
                  class="w-100"
                />
              </div>
              <div class="col-6" style="padding-left: 9px">
                <div
                  @click="showImage(4)"
                  :style="'background-image: url(' + data[4].image_thumb +  '); background-size: cover; height: calc(33vw - 9px)'"
                  class="w-100"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      v-if="data.length>5 && limited == false"
      style="padding: 0px 15px; margin-right: 0; margin-left: 0"
    >
      <div class="col-12 pl-0">
        <div class="row">
          <div
            class="col-6 o-hidden pr-0"
            style="padding-right: 9px"
            v-for="(i, index) in otherImages"
            :key="i"
          >
            <div
              @click="showImage(index+5)"
              :style="'background-image: url(' + i +  '); background-size: cover; height: calc(50vw - 9px)'"
              class="w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="tab-box" @click="limited = !limited" v-if="data.length>5">
      <div class="tab-footer">
        <h2 class="fc-1 fs-14" v-if="limited">
          <img src="/static/img/arrow-down.svg" class="mr-2" />
          Daha Fazla Göster
        </h2>

        <h2 class="fc-1 fs-14" v-if="!limited">
          <img src="/static/img/arrow-down.svg" class="mr-2" />
          Daha Az Göster
        </h2>
      </div>
    </div>

    <div
      class="modal modal-area photo-modal d-flex align-items-center"
      style="padding: 0;    top: 0;"
      v-if="modal"
    >
      <div
        class="modal-top position-absolute"
        style="    right: 24px; z-index: 9999"
        @click="modal = false"
      >
        <a href="javascript:;">
          <img src="/static/img/close-icon.svg" alt />
        </a>
      </div>
      <div class="modal-body w-100">
        <carousel :perPage="1" ref="carousel" @pageChange="pageChanged" :paginationEnabled="false">
          <slide v-for="i in data" :key="i.image">
            <div
              :style="'background-image: url(' + i.image +  '); background-size: contain; height: calc(100vh - 90px); background-repeat: no-repeat; background-position: center'"
              class="w-100"
            />
          </slide>
        </carousel>
      </div>
      <div class="modal-bottom position-absolute">
        <div class="row">
          <div class="col-2 text-center">
            <a href="javascript:;" @click="$refs.carousel.navigateTo = index != 0 ? index-1 : 0">
              <img src="/static/img/popup-left.svg" alt />
            </a>
          </div>
          <div class="col-8" style="display: flex; align-items: center; justify-content: center">
            <a href="javascript:;" @click="$emit('onShareClicked')" class="fs-16 fc-5">
              <img src="/static/img/popup-share.svg" class="mr-2" /> Paylaş
            </a>
          </div>
          <div class="col-2 text-center">
            <a
              href="javascript:;"
              @click="$refs.carousel.navigateTo = index != data.length ? index+1 : data.length"
            >
              <img src="/static/img/popup-right.svg" alt />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Gallery",
  props: ["data", "isLimited"],
  data() {
    return {
      index: 0,
      modal: false,
      limited: this.isLimited
    };
  },
  methods: {
    showImage(index) {
      this.index = index;
      this.modal = true;
    },
    pageChanged(index) {
      this.index = index;
    }
  },
  computed: {
    otherImages() {
      var data = JSON.parse(JSON.stringify(this.data));

      data.splice(0, 5);
      var data2 = [];

      data.map(item => {
        data2.push(item.image_thumb);
      });

      return data2;
    }
  },
  watch: {
    modal: function() {
      if (this.modal == true) {
        setTimeout(() => {
          this.$refs.carousel.navigateTo = this.index;
        }, 100);
        $("body").addClass("modal-on");
      } else {
        $("body").removeClass("modal-on");
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Gallery.vue